import {CHARTDESIGNER_LOAD_DATA_FOR_DATASTRUCTURE} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {
    ElusiveData,
    setElusiveData
} from '~/frontend/src/actions/elusiveData';
import dataLoadData from '~/frontend/src/actions/data/loadData';
import {
    LoadDataCommonParameters,
    LoadDataForDataStructureParameters,
    LoadDataResult
} from '~/shared/src/utilities/modules/chart';
import {MergeMode} from '~/frontend/src/utilities/dataUtils';
import {
    DataDescriptor,
    DataStructure
} from '~/shared/src/utilities/dataStructure';
import {Chart} from '~/shared/src/utilities/chart';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {string} dataContext
 * @param {Schema} schema
 * @param {MergeMode} mergeMode='override'
 * @param {DataStructure} dataStructure
 * @param {Chart[ 'data' ]} configData
 * @param {DataDescriptor | undefined} xAxisLabelDataDescriptor
 * @param {DataDescriptor[]} dataDescriptorsToSelect
 * @param {LoadDataCommonParameters} [params]
 *
 * @return {Promise<LoadDataResult | false>}
 */
const loadDataForDataStructure = ( panelKey : string, dataContext : string, schema : Schema, mergeMode : MergeMode = 'override', dataStructure : DataStructure, configData : Chart[ 'data' ], xAxisLabelDataDescriptor : DataDescriptor | undefined, dataDescriptorsToSelect : DataDescriptor[], params? : LoadDataCommonParameters ) : Thunk<Promise<LoadDataResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<LoadDataResult | false> => {
    dispatch( {
        type: CHARTDESIGNER_LOAD_DATA_FOR_DATASTRUCTURE,
        panelKey,
        dataContext,
        schema,
        mergeMode,
        dataStructure,
        configData,
        xAxisLabelDataDescriptor,
        dataDescriptorsToSelect,
        params
    } );

    const elusiveData                                        = getState().elusiveData?.[ panelKey ],
          newElusiveData : ElusiveData                       = {
              ...elusiveData
          },
          requestParams : LoadDataForDataStructureParameters = {
              schema,
              dataStructure,
              configData,
              xAxisLabelDataDescriptor,
              dataDescriptorsToSelect,
              ...params
          };

    let retVal : LoadDataResult | false = false;

    delete newElusiveData.data;
    dispatch( setElusiveData( panelKey, newElusiveData ) );

    await dispatch( dataLoadData(
        'chart/loadDataForDataStructure',
        dataContext,
        panelKey,
        'loadData',
        undefined,
        {
            params           : requestParams,
            mergeMode,
            extraMetaDataKeys: [ 'rowData', 'rowDataMapping', 'total' ]
        },
        false,
        ( data ) => {
            retVal = data as LoadDataResult;
        }
    ) );

    return retVal;
}
export type LoadDataForDataStructure = typeof loadDataForDataStructure;

export default loadDataForDataStructure;
